import React, { FC } from "react";
import classNames from "classnames";
import { useI18next } from "gatsby-plugin-react-i18next";
import { Link } from "@app/components/common/link/Link";
import { INavigationMenuGroup } from "@app/models/storyblok/datasource";

type Props = {
  data: INavigationMenuGroup[];
  onClose: () => void;
};

export const MenuGroup: FC<Props> = ({ data, onClose }) => {
  const { language, defaultLanguage } = useI18next();

  return (
    <div
      className={classNames(
        "bg-nav-light mt-2 space-y-7.5 rounded-2xl px-5 py-6",
      )}
    >
      {data.map((group) => (
        <div key={group.id}>
          <h6 className="text-extra-small text-nav-secondary mb-4">
            {group.groupName[language] ?? group.groupName[defaultLanguage]}
          </h6>
          <ul className="space-y-4">
            {group.entries.map((entry) => (
              <li key={entry.id}>
                <Link
                  to={entry.ref}
                  className="text-regular hover:text-base-content/50 no-underline duration-300"
                  onClick={onClose}
                >
                  {entry.name[language] ?? entry.name[defaultLanguage]}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
